import useFlightSearchPageParams from '@pages/FlightSearchResult/hooks/useFlightSearchPageParams';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useDocumentVisibility } from '@hooks/useDocumentVisibility';

const useHotelCrossSell = (isSearchExpired: boolean) => {
  const [searchParams] = useSearchParams();
  const isDocumentVisible = useDocumentVisibility();
  const selectedTripIdSearchParam = searchParams.get('selected_trip_id');
  const { isRoundTrip } = useFlightSearchPageParams();

  const [showCrossSellPopup, setShowCrossSellPopup] = useState(false);

  useEffect(() => {
    if (isDocumentVisible && !!selectedTripIdSearchParam && !isSearchExpired && isRoundTrip) {
      setShowCrossSellPopup(true);
    }
  }, [isDocumentVisible]);

  return {
    showCrossSellPopup,
    setShowCrossSellPopup,
  };
};

export default useHotelCrossSell;
